export default "__VITE_ASSET__DwZ8nSLt__"